import GeneralLedger from "@/views/reports/accountingreport/GeneralLedger.vue";

const state = {
    sales: [],
    finished: [],
    semi: [],
    raw: [],
    cost: [],
    production: [],
    balancesheet: [],
    profitandloss: [],
    trialBalance: [],
    generalLedger: [],
    tds: [],
    vatreturn: [],
    lead: [],
    conversion: [],
    payrollVariance : [],
    complaintResolutionTime: [],
    staffComplaintHandlingPerformance: [],
    customerComplaintFrequency: [],
    leadClientOpportunityCostSummary: [],
    customerTicketVolumeAnalysis: [],
    salesSummaryReport: [],
    SalesValueContributionBySalesperson: [],
    LeadAgingAnalysis: [],
    salesAnalyticsReport: [],
    salesAnalyticsReportByProduct: [],
    salesAnalyticsReportByClient: [],
    ticketCategoryReport: [],
    quotationPriorityReport: [],
    productionCostAnalysisReport: [],
    productionReport: [],
    productionLeadTimeAnalysisReport: [],
    projectCostAnalysisReport: [],
    projectStatusReport: [],
    inventoryValueAnalysisReport: [],
    inventoryQtyAnalysisReport: [],
    warehouseDistributionReport: [],
    monthlySpendingByPlatform: [],
    loading: false,
};

export default state;